module.exports = __webpack_public_path__ + "img/ilutration_audio.e7433a9c.png";